import {
    UPDATE_LINKED_PRODUCTS,
    UPDATE_LINKED_PRODUCTS_DATA
}
from 'Store/LinkedProducts/LinkedProducts.action';
import BrowserDatabase from 'Util/BrowserDatabase';
import { getIndexedProducts } from 'Util/Product';
import { mergeProducts } from 'Util/Variants';

import { LINKED_PRODUCTS } from './LinkedProducts.dispatcher';

export const UPSELL = 'upsell';

export const RELATED = 'related';

export const CROSS_SELL = 'crosssell';
/** @namespace Bodypwa/Store/LinkedProducts/Reducer/uniqueBySku */
export function uniqueBySku(items = []) {
    const seen = new Set();
    return items.filter((item) => {
      if (seen.has(item.sku)) {
        return false;
      }
      seen.add(item.sku);
      return true;
    });
}

/** @namespace Bodypwa/Store/LinkedProducts/Reducer/getInitialState */
export const getInitialState = () => ({
    linkedProducts: BrowserDatabase.getItem(LINKED_PRODUCTS) || {
        upsell: {},
        related: {},
        crosssell: {}
    }
});
/** @namespace Bodypwa/Store/LinkedProducts/Reducer/LinkedProductsReducer */
export const LinkedProductsReducer = (
    state = getInitialState(),
    action
) => {
    const {
        items
    } = action;
    const { configuredVariants, linkedProducts: { upsell, crosssell, related } = {} } = state;
    switch (action.type) {
    case UPDATE_LINKED_PRODUCTS_DATA:
        const initialVaraints = getIndexedProducts(items);

        const { mergedItems: mergedRelatedItems } = mergeProducts(related?.items || [], initialVaraints);
        const { mergedItems: mergedCrosssellItems } = mergeProducts(crosssell?.items || [], initialVaraints);
        const { mergedItems: mergedUpsellItems } = mergeProducts(upsell?.items || [], initialVaraints);

        return {
            ...state,
            linkedProducts: {
                [UPSELL]: {
                    items: mergedUpsellItems,
                    total_count: mergedUpsellItems.length
                },
                [RELATED]: {
                    items: mergedRelatedItems,
                    total_count: mergedRelatedItems.length
                },
                [CROSS_SELL]: {
                    items: uniqueBySku(mergedCrosssellItems),
                    total_count: uniqueBySku(mergedCrosssellItems).length
                }
            },
            configuredVariants
        };
    case UPDATE_LINKED_PRODUCTS:
        const {
            linkedProducts: {
                [UPSELL]: upsellItems,
                [RELATED]: relatedItems,
                [CROSS_SELL]: crosssellItems,
                updateCrossSell = false
            }
        } = action;

        const {
            linkedProducts: {
                [CROSS_SELL]: prevCrossSell
            }
        } = state;

        if (updateCrossSell) {
            return {
                ...state,
                linkedProducts: {
                    [UPSELL]: upsellItems,
                    [RELATED]: relatedItems,
                    [CROSS_SELL]: crosssellItems
                }
            };
        }

        return {
            ...state,
            linkedProducts: {
                [UPSELL]: upsellItems,
                [RELATED]: relatedItems,
                [CROSS_SELL]: {
                    ...prevCrossSell,
                    ...relatedItems,
                    items: Object.values({
                        ...crosssellItems.items
                    })
                }
            }
        };
    default:
        return state;
    }
};
export default LinkedProductsReducer;
